<div class="associations-container dark-mode">
    <div class="page-header mt-5">
        <div class="d-flex">
            <mat-icon class="back-button" [routerLink]="'/office/new-certification/detail/'+certification?.id">chevron_left</mat-icon>
            <h1 class="page-title">Add New Certification Domain</h1>
        </div>
        <div class="breadcrumb">
            <span class="breadcrumb-item">Dashboard</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/new-certification'">Certifications</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-item" [routerLink]="'/office/new-certification/detail/' + certification?.id">{{certification?.certificationTitle}}</span>
            <span class="breadcrumb-separator mx-2">/</span>
            <span class="breadcrumb-current">Add New Certification Domain</span>
        </div>
    </div>

    <hr class="mb-3" />

    <form [formGroup]="form">
        <div class="row">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Certification Title</mat-label>
                    <input type="text" matInput formControlName="certificationTitle">
                </mat-form-field>
            </div>
        </div>

        <div class="row mt-2">
            <div class="col-12">
                <mat-form-field class="full-width w-100" appearance="outline">
                    <mat-label>Association</mat-label>
                    <mat-select formControlName="providerId">
                        <mat-option *ngFor="let assoc of associations" [value]="assoc.id">
                            {{ assoc.providerName }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <h5 style="font-size: 16px" class="mt-2 text-white">Certification Domain and Objectives</h5>
        <mat-accordion class="mb-5" multi formArrayName="domains">
            <mat-expansion-panel [expanded]="true" *ngFor="let domain of domains.controls; let i = index" [formGroupName]="i">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <div class="title-container">
                            <span>Domain {{ i + 1 }}</span>
                            <mat-icon (click)="removeDomain(i); $event.stopPropagation()" class="button-flat crimson-red">delete</mat-icon>
                        </div>

                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="p-1 expansion-body">
                    <div class="row mt-3">
                        <div class="col-12">
                            <mat-form-field class="full-width w-100" appearance="outline">
                                <mat-label>Domain Name</mat-label>
                                <input type="text" matInput formControlName="domainName">
                            </mat-form-field>
                        </div>
                    </div>

                    <hr class="mb-3" />

                    <mat-accordion class="mb-3" multi formArrayName="objectives">
                        <mat-expansion-panel [expanded]="true" *ngFor="let objective of objectives(i).controls; let j = index" [formGroupName]="j">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="title-container">
                                        <span>Target Objective {{ j + 1 }}</span>
                                        <mat-icon (click)="removeObjective(i, j); $event.stopPropagation()" class="button-flat crimson-red">delete</mat-icon>
                                    </div>

                                </mat-panel-title>
                            </mat-expansion-panel-header>

                            <div class="p-1 expansion-body">
                                <div class="row mt-4">
                                    <div class="col-12">
                                        <mat-form-field class="full-width w-100" appearance="outline">
                                            <mat-label>Target Objective Name</mat-label>
                                            <input type="text" matInput formControlName="objectiveName">
                                        </mat-form-field>
                                    </div>
                                </div>

                                <div class="row mt-2">
                                    <div class="col-12">
                                        <app-tiptap-editor
                                                placeholder="Enter your term here..."
                                                formControlName="term"
                                                label="Exam objective terms"
                                                [required]="true"
                                        >
                                        </app-tiptap-editor>
                                    </div>
                                </div>

                            </div>


                        </mat-expansion-panel>
                    </mat-accordion>

                    <div class="p-1 text-center">
                        <div class="d-inline-flex mt-3 gap-3 add-new-activity button-flat" (click)="addObjective(i)">
                            <mat-icon class="gap-2">add</mat-icon><span class="d-block mt-1">Add More Objective</span>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>


        </mat-accordion>

        <div class="d-inline-flex mt-3 gap-3 add-new-activity button-flat" (click)="addDomain()">
            <mat-icon class="gap-2">add</mat-icon><span class="d-block mt-1">Add More Domain</span>
        </div>
        <div class="row my-5">
            <div class="col-12 text-end">
                <button mat-raised-button (click)="saveDomain()" class="edit-button">Save</button>
            </div>
        </div>
    </form>
</div>

